import { useLocale } from '../context/locale-context';

export default useLocale;
